import { render } from "./compliance_question_assignment.html?vue&type=template&id=1f824384&scoped=true&external"
import script from "./compliance_question_assignment.js?vue&type=script&lang=js&external"
export * from "./compliance_question_assignment.js?vue&type=script&lang=js&external"

import "./ComplianceQuestionAssignment.vue?vue&type=style&index=0&id=1f824384&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f824384"]])

export default __exports__